import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { getList } from './../store/reducers/partners'
import Swiper from 'react-id-swiper'

this.swiperRef2 = null

const params_logos = {
  grabCursor: false,//true
  centeredSlides: true,
  loop: true,
  rebuildOnUpdate: true,
  spaceBetween: 30,
}

const goNext = (ref) => {
  console.log(ref);
  if (ref && ref.swiper) {
    ref.swiper.slideNext();
  }
};
const goPrev = (ref) => {
  if (ref && ref.swiper) {
    ref.swiper.slidePrev();
  }
};

const PartnersPage = ({ items = {}, categories }) => (
  <div className='Partners'>
    <div className='Container Container_light'>
      <h1 className='Head Partners__title'>
        <FormattedMessage id='partners.partners' />
      </h1>
      <p className='Text Partners__caption'>
        <FormattedMessage id='partners.write_us' />
        {': '}
        <a href='mailto:meetforimpact@yandex.ru' className='Link'>meetforimpact@yandex.ru</a>
      </p>

      { categories.map(category => (
        <div className='Partners__list _swiperList' key={category._id}>

          {/*category.items.map(itemId => {
            if (!items[itemId] || !items[itemId].image) return null
            console.log('что мы тут получаем--------------', items);
              return (
                <div className='Partners__img'>
                  <img src={items[itemId].image} alt={items[itemId].name} key={`image-${itemId}`} />
                </div>
              )
          })*/}
          <button onClick={()=>goPrev(this.swiperRef2)} className="partners-slider-prev"></button>
          <Swiper {...params_logos}  ref={instance=>this.swiperRef2=instance} className="Partners__list__swiper" slidesPerView={(window.innerWidth < 667) ? 1 : 3}>
            {category.items.map(itemId => {
              if (!items[itemId] || !items[itemId].image) return null
                return (
                  <div className='Partners-item'>
                    <span>
                      <img className='Partners-item-img' src={items[itemId].image} alt={items[itemId].name} key={`image-${itemId}`} />
                    </span>
                  </div>
                )
            })}
          </Swiper>
          <button onClick={()=>goNext(this.swiperRef2)} className="partners-slider-next"></button>
        </div>
      ))}
    </div>
  </div>
)

const mapStateToProps = state => ({
  ...state.partners,
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ getList }, dispatch)

export default compose(
  withState('focusSlide', 'setFocusSlide', undefined),
  withState('ordinaryMode', 'setOrdinaryMode', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    setSize: (props) => e => {
      if (window.innerWidth < 667)
        props.setOrdinaryMode(true)
      else
        props.setOrdinaryMode(false)
    },
  }),
  lifecycle({
    componentWillMount () {
      if (!this.props.items || !this.props.items.length) this.props.getList();
      this.props.setSize()
      window.addEventListener('resize', this.props.setSize);
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.setSize);
    }
  })
)(PartnersPage)



// WEBPACK FOOTER //
// ./src/containers/Partners.jsx